export const FILE_DIALOG = "FILE_DIALOG";
export const PREFERENCE = "PREFERENCE";
export const SET_PREFERENCE = "SET_PREFERENCE";

export const SERVERMODE = "servermode";
export const CHECK = "check"; // 检查客户端
export const LOGIN = "login"; // 登录
export const LOGOUT = "logout"; // 注销
export const SERVERS = "servers"; // 获取能够连接的所有server列表
export const UPLOAD = "upload"; // 上传
export const DOWNLOAD = "download"; // 下载
export const DOWNLOADTO = "downloadto"; // 下载到
export const LS = "list"; // 列出当前文件夹下的文件列表
export const MV = "mv"; // 移动
export const RM = "remove"; // 删除
export const RN = "rename"; // 重命名
export const MKDIR = "create_folder"; // 新建文件夹
export const GET_TRANS_COUNT = "get_trans_count"; // 获取当前用户正在传输任务数
export const OPEN_TRANS_LIST = "open_trans_list"; // 打开传输列表
export const START_UPDATE = "start_update";
export const START = "start"; // 启动
export const RESTART = "restart"; // 重启
export const SHUTDOWN = "shutdown"; // 关闭
export const SESSIONS = "sessions"; // 获取FTP-SERVER的全部会话
export const PERFORMANCE = "performance"; // 获取cpu disk netstat等性能信息
export const LICENSE = "license";
export const GET_ERROR_INFO = "get_error_info"; // 获取错误日志
export const ACTIVE_WINDOW = "active_window";
export const TIMING_TASK = "timing_task"; // 创建同步目录任务
export const UPDATE_ALL_NORMAL_TASK = "update_all_normal_task"; // 切换线路后更新传输信息
